// src/services/checklistService.ts
import { apiMethods } from './api';

export interface ItemRequisito {
  id?: number;
  descricao_item: string;
  obrigatorio: boolean;
  ordem: number;
}

export interface Requisito {
  id?: number;
  nome_requisito: string;
  descricao: string;
  peso_percentual: number;
  ordem: number;
  itens: ItemRequisito[];
}

export interface ChecklistData {
  descricao: string;
  requisitos?: Requisito[];
  itens?: Array<{
    descricao: string;
    peso: number;
    ativo: boolean;
  }>;
}

class ChecklistService {
  async createChecklist(checklistData: ChecklistData): Promise<any> {
    const response = await apiMethods.post('/checklists', checklistData);
    return response.success ? response.data : null;
  }

  async getChecklists(): Promise<any[]> {
    const response = await apiMethods.get('/checklists');
    return response.success ? response.data : [];
  }

  async getChecklistById(id: number): Promise<any> {
    const response = await apiMethods.get(`/checklists/${id}`);
    return response.success ? response.data : null;
  }

  async updateChecklist(id: number, checklistData: ChecklistData): Promise<any> {
    const response = await apiMethods.put(`/checklists/${id}`, checklistData);
    return response.success ? response.data : null;
  }

  async deleteChecklist(id: number): Promise<boolean> {
    const response = await apiMethods.delete(`/checklists/${id}`);
    return response.success;
  }

  async associateQuestionWithChecklist(questionId: number, checklistId: number): Promise<boolean> {
    const response = await apiMethods.post('/perguntas/checklists', {
      pergunta_id: questionId,
      checklist_id: checklistId
    });
    return response.success;
  }

  async getChecklistsByQuestion(questionId: number): Promise<any[]> {
    const response = await apiMethods.get(`/perguntas/${questionId}/checklists`);
    return response.success ? response.data : [];
  }
}

export const checklistService = new ChecklistService();
export default checklistService;